import { memoize } from 'lodash/function';
import configs from 'configs';
import { authHeaders } from './authHeader';
import request from './api/request';

const apiUrl = configs.beApiUrl;

const getSearchParamsApi = async () => {
  let response = null;

  const requestOptions = {
    url: `${apiUrl}/public/trials/searchParams`,
    headers: await authHeaders(),
    json: true,
  };

  try {
    response = await request.get(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while getting profile data:', ex);
    throw ex;
  }

  return response;
};

export const getSearchParams = memoize(
  () => getSearchParamsApi(),
  null,
);
